// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedBookingCancellationType {
  administrative: {"enum_constant":"administrative"};
  student: {"enum_constant":"student"};
  teacher: {"enum_constant":"teacher"};
}

export type BookingCancellationTypeId = keyof IParsedBookingCancellationType;
export type BookingCancellationTypeData = IParsedBookingCancellationType[BookingCancellationTypeId];
const data: BookingCancellationTypeData[] = [{"enum_constant":"administrative"},{"enum_constant":"student"},{"enum_constant":"teacher"}];
export default data;
